export default {"src":"/_next/static/media/light-purple-to-dark-purple-left.fc7ae192.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};